<script setup lang="ts">
import AccountMenu from "@/components/layout/AccountMenu.vue";
import { Search } from "@/components/icons";
import { useContentStore } from "@/stores/contentStore";
import { useMediaQuery } from "@vueuse/core";

defineProps<{ title: string }>();

const isLargeScreen = useMediaQuery("(min-width: 768px)");
const contentStore = useContentStore();

const handleSearchFocus = (e: any) => {
  e.target.blur();
  contentStore.showSearchModal = true;
};
</script>

<template>
  <div class="px-8 pb-4" v-if="isLargeScreen">
    <div
      class="flex items-center justify-between py-4 border-b border-border-secondary"
    >
      <h1 class="text-2xl font-black">{{ title }}</h1>
      <div class="flex items-center">
        <div class="relative mx-4 lg:w-80">
          <Search class="absolute left-4 top-3 text-icon-secondary" />
          <input
            class="py-3 pl-12 pr-4 rounded-xl bg-background-primary border border-border-primary shadow-card w-full h-12"
            type="text"
            :placeholder="$t('search.placeholder')"
            @focusin="handleSearchFocus"
          />
        </div>
        <AccountMenu />
      </div>
    </div>
  </div>
</template>
